if (!customElements.get('apollo-upsell')) {
  customElements.define(
    'apollo-upsell',
    class ApolloUpsell extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.tabItems = this.querySelectorAll('.apollo-upsell__tab-item');
        this.tabs = this.querySelectorAll('.apollo-upsell__tab');

        this.selectedVariantId = this.querySelector('.apollo-upsell__tab-item--active .apollo-upsell__tab-btn')?.dataset.variantId ?? null;

        this.tabItems.forEach((item) => {
          const btn = item.querySelector('.apollo-upsell__tab-btn');
          const tab = this.querySelector(`#${btn.dataset.target}`);
          btn.addEventListener('click', this.onTabBtnClick.bind(this, item, btn, tab));
        });

        this.stickyCompareAtPrice = document.querySelector('.sticky-atc__compare-at-price');
        this.stickyPrice = document.querySelector('.sticky-atc__price');
        this.collectionUpsell = document.querySelector(`#Upsell-${this.dataset.sectionId}`);

        subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { html } }) => {
          const apolloUpsell = html.getElementById(`Apollo-${this.dataset.sectionId}`);
          const tabItems = apolloUpsell.querySelectorAll('.apollo-upsell__tab-item');
          for (let i = 0; i < tabItems.length; i++) {
            const currentItem = this.tabItems[i];
            const newItem = tabItems[i];

            const currentBtn = currentItem.querySelector('.apollo-upsell__tab-btn');
            const newBtn = newItem.querySelector('.apollo-upsell__tab-btn');

            currentBtn.dataset.compareAtPrice = newBtn.dataset.compareAtPrice;
            currentBtn.dataset.price = newBtn.dataset.price;

            this.stickyCompareAtPrice = document.querySelector('.sticky-atc__compare-at-price');
            this.stickyPrice = document.querySelector('.sticky-atc__price');
          }
        })
      }

      onTabBtnClick(item, btn, tab) {
        this.tabItems.forEach((item) => item.classList.remove('apollo-upsell__tab-item--active'));
        item.classList.add('apollo-upsell__tab-item--active');
        this.selectedVariantId = btn.dataset.variantId ?? null;

        this.tabs.forEach((tab) => tab.classList.remove('apollo-upsell__tab--active'));
        tab.classList.add('apollo-upsell__tab--active');

        if (!this.collectionUpsell) {
          if (this.stickyCompareAtPrice) this.stickyCompareAtPrice.textContent = btn.dataset.compareAtPrice;
          if (this.stickyPrice) this.stickyPrice.textContent = btn.dataset.price;
        } else {
          this.collectionUpsell.updateApolloBox();
        }
      }

      getSelectedVariantId() {
        return this.selectedVariantId ?? null;
      }
    },
  );
}
